import { Box, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../analyzeSlice";

export default function ChartTableToggle() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.analyze);
   const { showChart } = state;

   function toggle() {
      dispatch(setState("showChart", !showChart));
   }

   return (
      <Box 
         sx={{ width: 100, display: "flex", justifyContent: "space-between", mb: 2 }} 
      >  
         <Typography
            variant={showChart ? "p16w700" : "p16w400"}
            onClick={toggle}
            sx={{backgroundColor: "#efefef", p: 1, py: 2, pl: 3, borderRadius: "30px 0 0 30px", cursor: "pointer"}}
         >
            Graph
         </Typography >
         <Typography sx={{backgroundColor: "#efefef", p: 1, py: 2}}>&nbsp;|&nbsp;</Typography> 
         <Typography
            variant={showChart ? "p16w400" : "p16w700"}
            onClick={toggle}
            sx={{backgroundColor: "#efefef", p:1, py: 2, pr: 3, borderRadius: "0 30px 30px 0", cursor: "pointer"}}
         >
         
            Table
         </Typography>
      </Box>
   );
}
